export default __webpack_public_path__ + "media/images/banners/bnr_award-6f0762a3b4356fcd2ba5d134324a8abf.jpg";